import { createStore } from 'vuex'

export default createStore({
  state: {
    sharedContactsCount : 0,
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
